import { VF_INPUT } from 'AppSrc/core/components/forms/form-base-components/v-f-input';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';

const fieldId = 'customer';

const initialValues = '';

const vFParams = {
  fieldTitle: 'Customer',
  characterLimit: 50, // don't forget to add to validator
  placeholder: 'Enter text',
};

const validator = (params) => {
  const {
    values,
  } = params;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const overCharacterLimit = commonValidation.textInput.isOverCharacterLimit(values[fieldId], vFParams.characterLimit);
  // const hasSpecialCharacter = commonValidation.textInput.hasSpecialCharacter(values[fieldId]);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((overCharacterLimit) ? 'Text exceeds character limit' : null);
  // errors[INLINE_ERRORS].push((hasSpecialCharacter) ? 'Special character < cannot be accepted in Ace' : null);
  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const customer = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_INPUT,
};

export { customer };
